import * as React from 'react';
import { useLocalStorage } from '@grandvisionhq/utils';

/**
 * Temporarily stores the return label URL and status in the local storage.
 * TODO - This should be replaced with a more permanent solution in MACC-18448
 *
 */ const useReturnStorage = ()=>{
    const [storage, setStorage] = useLocalStorage('returnStorage', undefined, (value)=>value === undefined
    );
    const add = React.useCallback((item)=>{
        setStorage(item);
    }, [
        setStorage
    ]);
    const remove = React.useCallback(()=>{
        setStorage(undefined);
    }, [
        setStorage
    ]);
    return React.useMemo(()=>[
            storage,
            {
                add,
                remove
            }, 
        ]
    , [
        storage,
        add,
        remove
    ]);
};

export { useReturnStorage };
//# sourceMappingURL=use-returns-storage.js.map
